module.exports = __webpack_public_path__ + "img/logo_college_white.1a4143b.png";